import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    loggedAdmin: {},
    isLoading: []
  },

  mutations: {
    setAdmin(state, admin) {
      state.loggedAdmin = admin;
    },

    setLoading(state, isLoading) {
      if (isLoading) state.isLoading.push(1);
      else state.isLoading.pop();
    }
  },

  actions: {
    setAdmin({ commit }, admin) {
      commit("setAdmin", admin);
    },

    setLoading({ commit }, isLoading) {
      commit("setLoading", isLoading);
    }
  },

  getters: {
    loggedAdmin: state => state.loggedAdmin,
    isLoading: state => state.isLoading
  }
});
